import { writable, get } from 'svelte/store';
import * as util from '../js/util.js';
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function createMyStore() {
    const { subscribe, set, update } = writable([]);
    var gettingCountries = false;
    return {
        subscribe, update,
        getCountries: async () => {
            var url = 'api/Country/getcountries'
            if (window.location.href.includes('test=true')) {
                url += '?istest=true';
            }
            const json = await util.fetchJson(url);
            update(n => json)
        },

        getCountry: async (countryId) => {
            var countries = get(countryStore);
            if (countries.length == 0) {
                if (!gettingCountries) {
                    gettingCountries = true;
                    await countryStore.getCountries();
                    countries = get(countryStore);
                    gettingCountries = false;
                }
                else {
                    await sleep(300);
                    countries = get(countryStore);
                    gettingCountries = false;
                }
            }

            var ret = countries.find(c => c.id == countryId);
            return ret;
        },
    };
}
export const countryStore = createMyStore();